import { Toaster } from 'sonner';
import type { ReactNode } from 'react';

/**
 * Toast provider — wrap `<Toaster />` de sonner.
 *
 * @remarks
 * Usage :
 * ```ts
 * import { toast } from 'sonner';
 * toast.success('Done');
 * ```
 *
 * Le `<Toaster />` doit être rendu UNE fois dans l'app, généralement haut
 * dans l'arbre. Position `top-right` par défaut.
 */
export function ToastProvider({ children }: { children: ReactNode }) {
  return (
    <>
      {children}
      <Toaster position="top-right" richColors closeButton />
    </>
  );
}
